import {SecondaryButton} from '@/shared-components/Button'
// import {useOktaAuth} from '@okta/okta-react'
// import {ROUTES} from '@/config/constants'
import {useAuth} from '@/hooks/useAuth'
import {useIntl} from 'react-intl'

export const Logout = () => {
  // const {oktaAuth} = useOktaAuth()
  const {formatMessage} = useIntl()
  const {instance} = useAuth()

  const onClickLogout = () => {
    instance.logoutRedirect({
      postLogoutRedirectUri: `${window.location.origin}/login`,
    })
  }

  return (
    <div className="flex justify-end">
      <SecondaryButton data-testid="btn-logout" onClick={onClickLogout}>
        {formatMessage({id: 'LOGOUT.LOGOUT_BUTTON'})}
      </SecondaryButton>
    </div>
  )
}
